var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsmenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 87.5,
    height: 87.5,
    viewBox: "0 0 87.5 87.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-cursor-6651119",
    transform: "translate(-6.25 -6.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3372",
    "data-name": "Group 3372"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12982",
    "data-name": "Path 12982",
    d: "M88.25,38.969l-3-.469a3.372,3.372,0,0,1-2.2-5.3l1.813-2.453a6.429,6.429,0,0,0-.641-8.406l-6.562-6.563a6.429,6.429,0,0,0-8.406-.641L66.8,16.953a3.378,3.378,0,0,1-5.3-2.187l-.469-3.016a6.43,6.43,0,0,0-6.391-5.5H45.36a6.43,6.43,0,0,0-6.391,5.5L38.5,14.766a3.378,3.378,0,0,1-5.3,2.188L30.75,15.141a6.429,6.429,0,0,0-8.406.641l-6.563,6.563a6.429,6.429,0,0,0-.641,8.406L16.953,33.2a3.372,3.372,0,0,1-2.2,5.3l-3,.469a6.43,6.43,0,0,0-5.5,6.391v9.281a6.43,6.43,0,0,0,5.5,6.391l3.016.469a3.32,3.32,0,0,1,2.578,2.031c1.055,2.106-1.105,4.152-2.2,5.719a6.429,6.429,0,0,0,.641,8.406l6.563,6.563a6.429,6.429,0,0,0,8.406.641L33.2,83.047a3.378,3.378,0,0,1,5.3,2.188l.469,3.016a6.43,6.43,0,0,0,6.391,5.5h9.281a6.43,6.43,0,0,0,6.391-5.5l.469-3.016a3.378,3.378,0,0,1,5.3-2.187l2.453,1.813a6.429,6.429,0,0,0,8.406-.641l6.563-6.562a6.429,6.429,0,0,0,.641-8.406L83.047,66.8a3.314,3.314,0,0,1-.391-3.266c.758-2.238,3.707-2.148,5.594-2.5a6.43,6.43,0,0,0,5.5-6.391V45.36a6.43,6.43,0,0,0-5.5-6.391ZM73.453,50A23.479,23.479,0,0,1,50,73.437c-31.117-1.312-31.109-45.566,0-46.875A23.479,23.479,0,0,1,73.453,50Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12983",
    "data-name": "Path 12983",
    d: "M50,29.688A20.345,20.345,0,0,0,29.672,50c1.117,26.945,39.543,26.938,40.656,0A20.345,20.345,0,0,0,50,29.688ZM63.422,41.172,57.25,60.922a3.918,3.918,0,0,1-3.687,2.719,3.349,3.349,0,0,1-2.891-1.516l-4-8.672-8.734-3.937a3.489,3.489,0,0,1-1.437-3.8,3.834,3.834,0,0,1,2.578-2.781l19.688-6.391a3.7,3.7,0,0,1,4.656,4.625Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12984",
    "data-name": "Path 12984",
    d: "M59.734,39.531,40.046,45.906a.7.7,0,0,0-.484.922L47.5,50.406l3.875-3.875a1.558,1.558,0,0,1,2.2,2.2l-3.859,3.875,3.625,7.859c.371.1.684.031.922-.484l6.188-19.75a.549.549,0,0,0-.719-.7Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsmenu);
export default __webpack_public_path__ + "static/media/settings menu.a6333c5cd238902dee0fa9f8d6be3db7.svg";
export { ForwardRef as ReactComponent };